'use strict';

function SessionUtm() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {};

  this.initAllReady = function () {};

  this._getMogoUTM = function () {
    var obj = {};
    var i = 0;
    if (Cookies('MogoUTM')) {
      var str = Cookies('MogoUTM');
      var UTMs = str.split('____');
      UTMs.splice(1);
      UTMs = UTMs[0].split('~');
      for (i = 0; i < UTMs.length; i++) {
        UTMs[i] = UTMs[i].split(':');
        obj[UTMs[i][0]] = UTMs[i][1].replace('(', '').replace(')', '');
      }
    }
    return obj;
  };

  this.setSessionUtm = function () {
    // this._createDebugCookies();
    var mogoUTM = this._getMogoUTM();

    if (mogoUTM) {
      var campaignNameInput = document.createElement('input');
      if (mogoUTM.Campaign) {
        campaignNameInput.type = 'hidden';
        campaignNameInput.name = 'campaign_name';
        campaignNameInput.value = mogoUTM.Campaign;
        this._form.appendChild(campaignNameInput);
      }

      var campaignMediumInput = document.createElement('input');
      if (mogoUTM.Medium) {
        campaignMediumInput.type = 'hidden';
        campaignMediumInput.name = 'campaign_medium';
        campaignMediumInput.value = mogoUTM.Medium;
        this._form.appendChild(campaignMediumInput);
      }

      var campaignSourceInput = document.createElement('input');
      if (mogoUTM.Source) {
        campaignSourceInput.type = 'hidden';
        campaignSourceInput.name = 'campaign_source';
        campaignSourceInput.value = mogoUTM.Source;
        this._form.appendChild(campaignSourceInput);
      }

      var campaignTermInput = document.createElement('input');
      if (mogoUTM.Term) {
        campaignTermInput.type = 'hidden';
        campaignTermInput.name = 'campaign_term';
        campaignTermInput.value = mogoUTM.Term;
        this._form.appendChild(campaignTermInput);
      }

      var campaignContentInput = document.createElement('input');
      if (mogoUTM.Content) {
        campaignContentInput.type = 'hidden';
        campaignContentInput.name = 'campaign_content';
        campaignContentInput.value = mogoUTM.Content;
        this._form.appendChild(campaignContentInput);
      }
    }
  };
}